// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1cZxE","right":"styles_right__3i-hW"};